module.exports = __webpack_public_path__ + "7e5feb3a3d4b8b6727657f427d211679.svg";